import React, { FC } from "react";
import { Form, Input } from "antd";
import { useTranslation } from "react-i18next";

import StepsFormItem, { RequirementConfirmLabel } from "@/pages/Requirement/components/StepsFormItem";
import { RequirementConfirmTypeEnum } from "@/types/requirement";

interface RequirementFormProps {
  disableItems?: Array<RequirementConfirmTypeEnum>; // 禁止选择与拖拽项目
  onValuesChange?: (changedValues: RequirementFieldType, allValues: RequirementFieldType) => void;
  greyItems?: Array<RequirementConfirmTypeEnum> //不选择，不拖拽
  handleAdd?: boolean;
}

export type RequirementFieldType = {
  steps?: Array<RequirementConfirmLabel>;
  tip?: string;
  mrd?: number;
  eps?: number;
  preFinishDate?: number;
};

const RequirementForm: FC<RequirementFormProps> = ({ onValuesChange, disableItems, greyItems, handleAdd = false }) => {
  const { t } = useTranslation();

  return (
    <Form onValuesChange={onValuesChange} initialValues={{ tip: '' }}>
      <Form.Item label={t('requirement.flow')} name="steps">
        <StepsFormItem disableItems={disableItems} greyItems={greyItems} />
      </Form.Item>
      <Form.Item label={t('requirement.desc')} name="tip" hidden={!handleAdd}>
        <Input.TextArea
          autoSize={{ minRows: 6, maxRows: 20 }}
          placeholder={t("requirement.plDesc")}
        />
      </Form.Item>
    </Form>
  );
};

export default RequirementForm;